import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './ExcessInsuranceModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import messages from '../../locale/messages';
import insurance_image from '../../../public/siteImages/insuranceImage.jpg';

class ExcessInsuranceModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="insuranceModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                            <img src={insurance_image} alt="" className={cx(s.carImage)} />
                            <h2 className={cx(s.titleText)}>What is Excess Insurance?</h2>
                            <p className={cx(s.contentText)}>Excess insurance for car rentals is an optional coverage that protects you from paying a high deductible if the rental vehicle is damaged or stolen. When you rent a car, you’re typically responsible for an excess amount—the maximum out-of-pocket expense in case of an incident—which can be quite substantial; with excess insurance, this cost is covered by the insurer, transferring the financial risk and ensuring a safer, more stress-free rental experience.</p>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(ExcessInsuranceModal))); 
